import BasicRoute from "components/routes/BasicRoute";
import AutomatizadorUnificado from "components/AutomatorLaudoUpdate/AutomatizadorUnificado";

export default function RoutesMenusAtualizacaoMassa() {

    return <>

        <BasicRoute
            perfilAuth={['r9jrEQXznNgjrZTGCfch']} //admin only
            uid="assistente-atualizacao"
            route="assistente-atualizacao"

            menuProps={{
                text: "Assist. Atualização Laudos",
                sequence: "222221",
                iconName: 'AutoFixHigh',
            }}

            element={<AutomatizadorUnificado />}
        />
    </>;
}
